import moment from 'moment';
import { IDefectCategory } from '@/models/IDefectNotice';
import { DateFormat } from '@/plugins/date-filter';

export class DefectHelper {
  public defaultDateFor(id: string, categories: any[], receivedDate: Date) {
    var defaultMonths = 1;
    var selectedCategory = categories.filter(x => x.id == id);
    if (selectedCategory && selectedCategory.length) {
      defaultMonths = selectedCategory[0].defaultScheduleMonths;
    }

    let defaultDate = receivedDate;
    defaultDate.setMonth(defaultDate.getMonth() + defaultMonths);
    return moment(defaultDate);
  }

  public maxDateForDefectCategory(category: IDefectCategory, received: Date | number | string) {
    return moment(received)
      .add(category.defaultScheduleMonths, 'M')
      .format(DateFormat.Canonical);
  }
}

export default new DefectHelper();
